<template>
    <div class="afu-text-sm afu-leading-5 afu-text-secondary">
        {{ $t('search_results.showing') }}
        <span
            v-if="!total"
            class="font-semibold"
        >
            0
        </span>

        <template v-else>
            <template v-if="!mapView">
                <span class="afu-font-semibold">{{ showingFrom }}</span>
                {{ $t('search_results.separator') }}
                <span class="afu-font-semibold">{{ showingTo }}</span>
                {{ $t('search_results.of') }}
            </template>
            <span class="afu-font-semibold">{{ total | numeral }}</span>
        </template>
        {{ $t('search_results.results') }}
    </div>
</template>

<script>
    import numeral from 'numeral';

    export default {
        name: 'C1PaginatorShowingResults',

        filters: {
            numeral(value, pattern) {
                if (!value) {
                    return;
                }
                return numeral(value).format(pattern || '0,0');
            },
        },

        props: {
            perPage: {
                type: [String, Number],
                default: 0,
            },

            currentPage: {
                type: [String, Number],
                default: 0,
            },

            total: {
                type: [String, Number],
                default: 0,
            },

            mapView: {
                type: [Boolean],
                default: false,
            },
        },

        computed: {
            showingFrom() {
                const perPage = this.perPage;
                const currentPage = this.currentPage;

                return (perPage * (currentPage - 1)) + 1;
            },

            showingTo() {
                const perPage = this.perPage;
                const currentPage = this.currentPage;
                const total = this.total;
                const to = perPage * currentPage;

                return to > total ? total : to;
            },
        },
    };
</script>
